import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { Location } from '@angular/common';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import 'zone.js';
import '@angular/compiler';

if (environment.production) {
  enableProdMode();
}

if (window && environment.hideConsoleLogs){
  window.console.log = () => {};
}

// eslint-disable-next-line @typescript-eslint/naming-convention, no-underscore-dangle, id-blacklist, id-match
const __stripTrailingSlash = (Location as any).stripTrailingSlash;
(Location as any).stripTrailingSlash = function _stripTrailingSlash(url: string): string {
  return /^[a-z]{2}-[a-z]{2}$/.test(url) ? url + '.' : __stripTrailingSlash(url);
};

// Temporary Angular 21 compatibility fix: retain Zone-based rendering for legacy async callbacks.
// platformBrowserDynamic is deprecated since Angular 20; migrate it separately to platformBrowser.
// As of 2026-09-22, no removal version is documented, and provideZoneChangeDetection is not deprecated.
// TODO: Complete the zoneless migration before removing this Zone opt-in and the Zone.js imports.
// Make async state updates notify Angular via signals, AsyncPipe or markForCheck; OnPush is recommended,
// not required (for now), and changing the strategy alone is insufficient. Verify loaders and native event handlers.
platformBrowserDynamic().bootstrapModule(AppModule, {
  applicationProviders: [provideZoneChangeDetection()],
}).catch(err => console.error(err));
